import Layout from "@/components/layout/layout";
import NavigationTabs from "@/components/layout/navigationtabs";
import { AuthPage } from "@/auth/AuthPage";
import { useAuth } from "@/auth/useAuth";
import { supabase } from "@/api/supabase";
import { useActiveTab } from "@/hooks/useActiveTab";
import { NewsletterProvider } from "@/features/newsletterSettings/context/NewsletterProvider";
import { Outlet } from "react-router-dom";

function App() {
  const { session, authLoading } = useAuth();
  const { activeTab, handleTabChange } = useActiveTab();

  if (authLoading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
      </div>
    );
  }

  if (!session) {
    return <AuthPage />;
  }

  return (
    <NewsletterProvider>
      <div className="w-full flex flex-col min-h-screen">
        <style>
          {`
            .dot-pattern {
              background-image: radial-gradient(#000 1px, transparent 1px);
              background-size: 16px 16px;
            }
          `}
        </style>

        <div className="relative">
          <div className="absolute inset-0 pointer-events-none opacity-20 dot-pattern"></div>

          <div className="relative z-10">
            <div className="max-w-2xl mx-auto flex justify-between items-center p-4">
              <div className="flex items-center gap-2">
                <span className="text-2xl">👋</span>
                <span className="font-medium">
                  Welcome back,{" "}
                  <span className="px-1">
                    {session?.user.user_metadata.name?.split(" ")[0]}
                  </span>
                </span>
              </div>
              <button
                onClick={() => supabase.auth.signOut()}
                className="px-3 py-2 text-sm text-gray-600 hover:text-gray-900
                  border-2 border-gray-300 rounded-lg bg-white hover:bg-gray-50 
                  transition-colors duration-200"
              >
                Sign Out
              </button>
            </div>
          </div>

          <NavigationTabs activeTab={activeTab} onTabChange={handleTabChange} />
        </div>

        <div className="w-full p-4 space-y-4 flex flex-col min-h-screen max-w-4xl mx-auto">
          <Layout>
            <Outlet />
          </Layout>
        </div>
      </div>
    </NewsletterProvider>
  );
}

export default App;
